import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useRetailStores from './useRetailStores';

const useCurrentShowroom = () => {
  const location = useLocation();
  const { stores, loading, error } = useRetailStores();

  const showroom = useMemo(() => {
    if (!stores || stores.length === 0) return null;
    return stores.find(s => s.slug === location.pathname);
  }, [stores, location.pathname]);

  return {
    showroom,
    loading,
    error,
  };
};

export default useCurrentShowroom;
